import * as Yup from 'yup';

export const validationSchemaInvoice = Yup.object().shape({
  subject: Yup.string()
    .required('Subject Is Required')
    .max(100, 'Subject must be at most 100 characters'),

  accountName: Yup.string().required('Account Name Is Required'),
  invoiceDetails: Yup.array().of(
    Yup.object().shape({
      productId: Yup.string().required('Product Name is required'),
    })
  ),
});
